module.exports = __webpack_public_path__ + "53f117d6857e7efcc400f7d3f35395b1.pdf";